/**
 * @file: convertHtmlToText.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { convert as html2text } from 'html-to-text';

export function convertHtmlToText(html: string) {
  return html2text(html).trim();
}
